import React, { useState } from "react";
import { GetAccess } from "../../../utils/RolesandAccess";
import { AddIcon } from "../../../assets/icons";
import { TableLoader } from "../../../components/Loader";
import UseGetData from "../../../hooks/useFetchData";
import ViewMore from "./viewMore";
import CreateorUpdate from "./form";
import { useParams } from "react-router-dom";

function ManualStatusIndex() {
  const {stdId} = useParams();
  const { data, getData, isLoading } = UseGetData({ url: `/manual_status_update/get_by_standard_id/${stdId}` });
  const [showMyModal, setShowMyModal] = useState(false);
  

  return (
    <>
      <div className=" w-full h-[calc(100vh-140px)] overflow-y-auto">
        <div className="pb-2 px-2 flex justify-between items-center w-full">
          <h4 className="text-sm 2xl:text-base font-medium text-heading">
          Manual Status
          </h4>
          <div className=" w-8 flex justify-center items-center cursor-pointer">
            {GetAccess("admin_create") && (
              <div onClick={() => setShowMyModal(true)}>
                <AddIcon />
              </div>
            )}
          </div>
        </div>
        <div className=" w-full h-[calc(100vh-180px)]  relative overflow-y-auto">
          <div className=" sticky top-0 z-10">
            <table className="table-auto w-full">
              <thead className="bg-tabletitle">
                <tr className="flex items-center text-xs 2xl:text-sm font-medium">
                  {header?.map((header) => (
                    <th
                      className={`text-center py-4 font-medium ${header.width}`}
                    >
                      {header?.headone}
                    </th>
                  ))}
                </tr>
              </thead>
            </table>
          </div>
          <div>
            <table className="table-auto w-full">
              {isLoading == true ? (
                <>
                  {[...Array(4)].map((_, index) => {
                    return <TableLoader key={index} header={header} />;
                  })}
                </>
              ) : (
                <>
                  {data &&
                    data.map((data, i) => (
                      <tr
                        className="odd:bg-tableodd w-full even:bg-tableeven text-xs 2xl:text-sm py-1 flex justify-between items-center my-1"
                        key={i}
                      >
                        <td
                          className={`text-center px-5 text-gray-900 py-1 w-[15%]`}
                        >
                          {data.serial_number || "#"}
                        </td>
                        <td
                          className={`text-center px-5 text-gray-900 py-1 w-[40%] capitalize`}
                        >
                        {data.name =="documents_preperations"?"Document Preparation":data.name =="management_review"?"Management Review":data.name =="audit_schedule"?"Audit Schedule":data.name =="security_incident_review"?"Security Incident Review":"-"}
                        </td>
                        <td
                          className={`text-center px-5 text-gray-900 py-1 w-[40%] capitalize`}
                        >
                          {data?.status_name || "-"}
                        </td>
                        <td className={`text-center text-gray-900 py-1 w-[5%]`}>
                          <div className=" w-full h-full flex justify-center items-center">
                            <ViewMore data={data} fetcher={getData} />
                          </div>
                        </td>
                      </tr>
                    ))}
                </>
              )}
            </table>
          </div>
        </div>
      </div>
      <CreateorUpdate
        onClose={() => setShowMyModal(false)}
        visible={showMyModal}
        refreshData={getData}
      />
    </>
  );
}

export default ManualStatusIndex;

const header = [
  {
    headone: "SI. No",
    width: "w-[15%]",
  },
  {
    headone: "Module",
    width: "w-[40%]",
  },
  {
    headone: "Status",
    width: "w-[40%]",
  },
  {
    headone: " ",
    width: "w-[5%]",
  },
];
